import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { colors } from "@/theme/colors";

type Props = {
  address: string;
  access: string;
  phoneNumber: string;
  businessHour: string;
  regularClosingDay: string;
};

// ラベル・値の 1 行分。空文字の項目は表示しない。
function InfoRow({ label, value }: { label: string; value: string }) {
  if (!value) return null;
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        gap: { xs: 0.5, sm: 1.5 },
        py: 1.5,
      }}
    >
      <Typography
        sx={{
          width: { sm: 96 },
          flexShrink: 0,
          color: colors.textMuted,
          fontSize: 14,
          fontWeight: 600,
        }}
      >
        {label}
      </Typography>
      <Typography sx={{ color: colors.textBody, fontSize: 16, whiteSpace: "pre-line" }}>
        {value}
      </Typography>
    </Box>
  );
}

/**
 * 店舗情報 (住所・アクセス・電話番号・営業時間・定休日) の表示ブロック。
 */
export function ShopInfoSection({
  address,
  access,
  phoneNumber,
  businessHour,
  regularClosingDay,
}: Props) {
  const { t } = useTranslation();
  return (
    <Box>
      <InfoRow label={t("shopDetail.address")} value={address} />
      <InfoRow label={t("shopDetail.access")} value={access} />
      <InfoRow label={t("shopDetail.phoneNumber")} value={phoneNumber} />
      <InfoRow label={t("shopDetail.businessHour")} value={businessHour} />
      <InfoRow label={t("shopDetail.regularClosingDay")} value={regularClosingDay} />
    </Box>
  );
}
